import { Trans } from "@lingui/react/macro";

import {
  Button,
  PlanUpgradeCta,
} from "@/routes/shared/components/plan-upgrade-cta/plan-upgrade-cta";

import ShopSvg from "./assets/shop.svg?react";

const IWantToTradeDialog = ({ onClick }: { onClick: () => void }) => {
  return (
    <PlanUpgradeCta
      description={
        <Trans>
          Ceny garantované obchodníky, kteří vkládají cenu do systému.
        </Trans>
      }
      heading={<Trans>Toto jsou závazné výkupní ceny.</Trans>}
      icon={
        <ShopSvg className="h-12 w-12 sm:h-6 sm:w-6 @max-sm:h-12 @max-sm:w-12" />
      }
    >
      <Button onClick={onClick}>
        <Trans>Chci obchodovat</Trans>
      </Button>
    </PlanUpgradeCta>
  );
};

export { IWantToTradeDialog };
